<template>
  <v-main>
    <v-container >
      <v-row class="mt-16">
        <v-col>
          <p class="notfound text-h2 text-sm-h1 text-lg-h1 text-center">
            Page Not Found
          </p>
          <p class="text-h5 text-sm-h5 text-lg-h5 text-center">
            We're sorry, but that page could not be found
          </p>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="mt-16">
      <v-row align="stretch" justify="center">
        <v-col cols="12" md="4" class="px-8" style="z-index: 1">
          <v-card
            shaped
            outlined
            height="100%"
          >
            <v-card-text>
              <p class="text-h4 text--primary">Get in touch</p>
              <div class="text--primary">
                If you've reached this page and think it's an error. Please
                give us a call or send an email by clicking the link below:
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                color="#006FFF"
                href="https://landrumworkforcesolutions.com/candidate-contact"
              >
                Contact Us
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" class="px-8" style="z-index: 1">
          <v-card
            shaped
            outlined
            height="100%"
          >
            <v-card-text>
              <p class="text-h4 text--primary">Why am I here</p>
              <div class="text--primary">
                If you arrived here from another webpage it's possible that
                the information is old or that the link has expired. If you like
                more information please click 'Contact Us' to speak with a representative.
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <meta name="robots" content="noindex"/>
  </v-main>
</template>

<script>
export default {
  name: 'NotFound',
  data: () => ({
    temp: null,
  }),
};
</script>

<style lang="scss" scoped>

</style>
